/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import '../../css/style.css';
import Button from "@components/Button";
import {Toaster} from "react-hot-toast";
import {t} from "@util/i18n";

interface HomeScreenProps {
	openFileFunc: (event: React.MouseEvent<HTMLButtonElement>) => void;
	imageToBig: boolean;
	setImageToBig: (status: boolean) => void;
}


function HomeScreen({openFileFunc, imageToBig, setImageToBig}: HomeScreenProps) {

	const isMobile = window.innerWidth <= 768;

	const backgroundImageStyle = {
		backgroundSize: 'cover',
		backgroundPosition: 'center bottom',
		backgroundAttachment: 'fixed'
	};

	return (
		<div className="bgDiv homeScreenContainer" style={backgroundImageStyle}>
			{isMobile ? (
				!imageToBig ? (
					<>
						<h2 className="homeScreenTitle titleText baseText">{t("homeTitle")}</h2>
						<h2 className="homeScreenText baseText">{t("homeSubtitle")}</h2>
						<Button additionalClasses="addPhotosBtn" onClick={openFileFunc}>{t("addPhotos")}</Button>
					</>
				) : (
					<>
						<h2 className="homeScreenTitle titleText baseText">{t("errorTitle")}</h2>
						<h2 className="homeScreenText baseText">{t("tooLargeBody")}</h2>
						<Button additionalClasses="addPhotosBtn" onClick={() => setImageToBig(false)}>{t("ok")}</Button>
					</>
				)
			) : (
				<div className="homeWebBgContainer">
					{!imageToBig ? (
						<>
							<h2 className="homeScreenTitle titleText baseText">{t("homeTitle")}</h2>
							<h2 className="homeScreenText baseText">{t("homeSubtitle")}</h2>
							<Button additionalClasses="addPhotosBtn" onClick={openFileFunc}>{t("addPhotos")}</Button>
						</>
					) : (
						<>
							<h2 className="homeScreenTitle titleText baseText">{t("errorTitle")}</h2>
							<h2 className="homeScreenText baseText">{t("tooLargeBody")}</h2>
							<Button additionalClasses="addPhotosBtn" onClick={() => setImageToBig(false)}>{t("ok")}</Button>
						</>
					)}
				</div>
			)}
			<Toaster toastOptions={{className: 'baseText'}}/>
		</div>


	);
}

export default HomeScreen;
